import { Injectable } from '@angular/core';
// import { AuthHttp } from 'angular2-jwt';
// import { Http, Headers } from '@angular/http';
// import { AuthService } from './auth/auth.service';
import { LoginResult } from '../models/LoginResult';
import * as Cookie from 'js-cookie';

@Injectable()
export class DataService {
  public userDisplayInfo: LoginResult;
  private userInfoInLocalStorage: string;

  constructor(
  ) {

    console.log('Data Service Initialized...');

    // To fix IE 11
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

    if (isIEOrEdge) {
      if (Cookie.get('displayUserInfo') !== undefined) {
        this.userDisplayInfo = JSON.parse(Cookie.get('displayUserInfo'));

        // alert(this.userDisplayInfo);
        console.log('get userDisplayInfo from cookie.' + this.userDisplayInfo);
      }
    } else {
      this.userInfoInLocalStorage = localStorage.getItem('displayUserInfo');

      if (!this.userDisplayInfo && this.userInfoInLocalStorage !== null && typeof this.userInfoInLocalStorage !== 'undefined') {
        this.userDisplayInfo = JSON.parse(this.userInfoInLocalStorage);
        console.log('get userDisplayInfo from localstorage.' + this.userDisplayInfo);
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/services/data.service.ts